import { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { dbUstaz } from "../firebaseConfig";

export default function useUstazMap(speakerIds = []) {
    const [map, setMap] = useState({});

    const sig = useMemo(
        () => [...new Set(speakerIds.filter(Boolean))].sort().join("|"),
        [speakerIds]
    );

    useEffect(() => {
        const ids = sig ? sig.split("|").filter(Boolean) : [];
        if (ids.length === 0) {
            setMap({});
            return;
        }

        const unsubs = ids.map((id) =>
            onSnapshot(doc(dbUstaz, "asatizah", id), (snap) => {
                setMap((prev) => ({ ...prev, [id]: snap.exists() ? snap.data() : null }));
            })
        );

        return () => unsubs.forEach((u) => u && u());
    }, [sig]);

    return map;
}
